import React  from 'react'
import mathHelper from '../../../Helpers/mathHelper';


class TargetRate extends React.Component 
{
    static defaultProps=
    {
        rates:[20,30,30,20],
        onChange: (value) => alert(value), 
        className: 'form-control form-control-sm',
        disabled: false,
    }
    constructor(props) 
    {
        super(props);
        this.state = {
            rates:props.rates
        };
    }

    componentDidMount() 
    {
        
    }

    componentDidUpdate()
    {
        if(this.state.rates!==this.props.rates)
        {
            this.setState({rates:this.props.rates});
        }
    }

    rateChange(index,value)
    {
        let tempRates=this.state.rates;
        tempRates[index]=isNaN(parseInt(value))?0:parseInt(value);
        if(index<3)
        {
            let sum=0;
            for (let i = 0; i < 4; i++)
            {
                if(i>index)
                {
                    tempRates[i]=Math.max(Math.ceil((100-sum)/(4-i)),0);
                }
                sum+=tempRates[i];
            }
        }
        this.setState({rates:tempRates});
        this.props.onChange(tempRates);
    }

    renderInput(index, cn)
    {
        return(
            <input
                type="number"
                key={"field"+index}
                className={this.props.className+' text-center'+cn}
                value={mathHelper.RemoveLeadingZeros(this.state.rates[index])}
                onChange={(e)=>this.rateChange(index, e.target.value)}
                disabled={this.props.disabled}
                min={0}
                max={100}
            />
        );
    }

    render()
    {
        let cn=(mathHelper.Sum(this.state.rates)!==100 && !this.props.disabled ? " bg-warning" : "");
        let rateFields=[];
        for (let i = 0; i < 4; i++) 
        {
            rateFields.push(this.renderInput(i, cn));               
        }
        return (
            <div className="d-flex">
                {rateFields}
            </div>
        );
    }
}


export default TargetRate;
